module.exports = __webpack_public_path__ + "static/assets/80750d62f2f4e47f0ff3bc8f4af5acdb.png";